import { store, getContext, getElement, getConfig } from '@wordpress/interactivity';

const { state } = store( 'cnm-menu', {
    actions: {
        closeMenu: () => {
            if(state.isOpen){
                const context = getContext();
                state.isOpen = false;
                document.body.classList.remove('cnm-popup-toggled', 'cnm-menu-toggled');
                document.getElementById('cnm-menu-close').remove();
                state.submenus.forEach((submenu, key) => {
                    state.submenus[key].isOpen = false;
                });
                document.querySelectorAll('li.cnm-menu__list__item .active').forEach((el) => {
                    el.classList.remove('active');
                    el.setAttribute('aria-expanded', 'false');
                });
            }
        },
        toggleMenu: () => {
            state.isMenuOpen = !state.isMenuOpen;
        },
        toggleAgenda: () => {
            const agenda = store( 'cnm-agenda' );
            agenda.actions.toggle();
        },
        toggleSubmenu: () => {
            state.isOpen = true
            const context = getContext();
            const element = getElement();


            // Close search form
            const searchForm = document.querySelector('.cnm-search-form__form');
            if (searchForm && searchForm.offsetParent !== null) {
                const searchFormClose = document.querySelector('.cnm-search-form__close');
                if (searchFormClose) {
                    searchFormClose.click();
                }
            }
            
            // Add class to body
            document.body.classList.add('cnm-popup-toggled');
            document.body.classList.add('cnm-menu-toggled');

            // Close control
            if (!document.getElementById('cnm-menu-close')) {
                const closeLink = document.createElement('a');
                closeLink.href = '#';
                closeLink.id = 'cnm-menu-close';
                closeLink.innerHTML = '<i class="cnm-icon-Close"></i> Fermer';
                document.getElementById('cnm-menu-close-wrap').prepend(closeLink);
            }

            document.getElementById('cnm-menu-close-wrap').addEventListener('click', (event) => {
                event.preventDefault();
                state.isOpen = false;
                document.body.classList.remove('cnm-popup-toggled', 'cnm-menu-toggled');
                document.getElementById('cnm-menu-close').remove();
                state.submenus.forEach((submenu, key) => {
                    state.submenus[key].isOpen = false;
                });
                Object.keys(context.menus).forEach((key) => {
                    const menu = context.menus[key];
                    context.menus[key].isOpen = false;
                });
            });

            // Display submenu logic
            const controls = element.ref.getAttribute('aria-controls');

            Object.keys(context.menus).forEach((key) => {
                const menu = context.menus[key];
                if (menu.controls === controls) {
                    context.menus[key].isOpen = true;
                    state.focusedMenu = element.ref;
                }
                else{
                    context.menus[key].isOpen = false;
                }
            });

            const subMenuWrapper = document.getElementById(controls);

            state.submenus.forEach((submenu, key) => {
                if (submenu.id === controls) {
                    subMenuWrapper.innerHTML = submenu.content;
                    if(state.isMenuOpen){
                        element.ref.parentNode.appendChild(subMenuWrapper.parentNode);
                    }
                    state.submenus[key].isOpen = true;
                    setTimeout(() => {
                        subMenuWrapper.querySelector('a').focus();
                    });
                    state.focusTrapElement = subMenuWrapper;
                }
                else{
                    state.submenus[key].isOpen = false;
                }
            });

        },
        focusTrap: (event) => {
			const context = getContext();
			if (!state.isOpen) return;
		
			if (event.key === 'Escape') {
				event.preventDefault();
                state.isOpen = false;
                document.body.classList.remove('cnm-popup-toggled', 'cnm-menu-toggled');
                document.getElementById('cnm-menu-close').remove();
                state.submenus.forEach((submenu, key) => {
                    state.submenus[key].isOpen = false;
                });
                Object.keys(context.menus).forEach((key) => {
                    const menu = context.menus[key];                    
                    context.menus[key].isOpen = false;
                });
                state.focusedMenu.focus();
                return;
			}
		
			if (event.key === 'Tab') {
				const focusableElements = Array.from(state.focusTrapElement.querySelectorAll(
					'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
				)).filter(el => !el.disabled && el.offsetParent !== null);
		
				if (focusableElements.length === 0) return;
		
				const firstElement = focusableElements[0];
				const lastElement = focusableElements[focusableElements.length - 1];
		
				if (event.shiftKey && document.activeElement === firstElement) {
					event.preventDefault();
					lastElement.focus();
				} else if (!event.shiftKey && document.activeElement === lastElement) {
					event.preventDefault();
					firstElement.focus();
				}
			}
		},
    }
});